import { useEffect, useState } from "react";
import { Form } from "../../common/Form";
import { CommonDialog } from "../../common/CommonDialog";
import { useTranslation } from "react-i18next";

export function OptionFormatDialog({visible,onOK,onCancel})
{    
    const {t} = useTranslation();
    const [optionFormat,setOptionFormat]=useState({columns:1,extraColumns:0,columnHeader:false,underlineHeaders:false});

    const onChange=(formData)=>{    
        if(formData.extraColumns>0)
            formData.columns=1;    
        setOptionFormat(formData);
    };
    const _onCancel=()=>{
        onCancel();
    };
    const _onOK=()=>{
        onOK(optionFormat);
    };
    useEffect(()=>{
    },[]);
    return(
        <>
        <CommonDialog header={t('Editor.Option_table_format')} visible={visible} onOK={_onOK} onCancel={_onCancel}>
            <div className="p-2" style={{maxWidth:'400px'}}>
            <Form id="formatOptionTable" formData={optionFormat} columns="1" onChange={onChange}
                fields={[
                    {id:"columns",ftype:"number",field:"columns",label:t('Editor.Options_in_a_row')},
                    {id:"extraColumns",ftype:"number",field:"extraColumns",label:t('Editor.Extra_columns')},
                    {id:"columnHeader",ftype:"checkbox",field:"columnHeader",label:t('Editor.Header_on_columns')},                    
                    {id:"underlineHeaders",ftype:"checkbox",field:"underlineHeaders",label:t('Editor.Underline_headers')}
                ]}>
            </Form>	
            </div>
        </CommonDialog>
        </>
    );
}